// extracted by mini-css-extract-plugin
export default {"root":"IconRefrigerator_root__uQU98"};